import "./adminSkeleton.css";

// One shimmer primitive. variant picks the shape; width/height override
// the default for that shape when a specific size is needed.
export const AdminSkeleton = ({ variant = "text", width, height, className = "" }) => (
  <span
    className={`admin-skeleton admin-skeleton--${variant} ${className}`.trim()}
    style={{ width, height }}
  />
);

// Renders `rows` skeleton rows shaped like AdminTable's real rows, so a
// loading table doesn't jump in height once real data arrives.
export const AdminTableSkeleton = ({ columns = 4, rows = 6 }) => (
  <div className="admin-table-skeleton" role="presentation" aria-hidden="true">
    {Array.from({ length: rows }).map((_, r) => (
      <div className="admin-table-skeleton__row" key={r}>
        {Array.from({ length: columns }).map((__, c) => (
          <AdminSkeleton key={c} variant="text" />
        ))}
      </div>
    ))}
  </div>
);
